export const toPercent = (fraction: number): string =>
  `${Math.round(fraction * 100)}%`;
